var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Tag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media-Library",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media-Library-Bulk-Tagging",
    transform: "translate(-886.000000, -1052.000000)",
    fill: "#B7844D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 1034.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(442.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_tag_2178979_000000",
    transform: "translate(444.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.717998423,0 L0.714091848,0 C0.319534251,0 -5.32930821e-16,0.320334287 -5.32930821e-16,0.714091848 L-5.32930821e-16,0.717998423 L0.0421898817,9.33158259 C0.0437523514,9.52768533 0.122661471,9.70503924 0.25157922,9.83316496 L10.2098234,19.7914091 C10.3395171,19.9211029 10.5176571,20.0007984 10.7145259,20.0007984 C10.9114106,20.0007984 11.0903226,19.9211069 11.2192284,19.7914091 L19.7906107,11.2200268 C19.9203044,11.090333 20,10.9121931 20,10.7153243 C20,10.5184555 19.9203084,10.3395275 19.7906107,10.2106218 L9.83236652,0.252377656 C9.70345477,0.123465907 9.52611286,0.0437683521 9.33078415,0.0429883173 L0.717998423,0 Z M1.43197227,1.43210387 L9.03082917,1.46882351 L18.2758415,10.7146359 L10.7145043,18.2759731 L1.4686919,9.03016075 L1.43197227,1.43142184 L1.43197227,1.43210387 Z M5.71428126,4.28623117 C4.93378645,4.28623117 4.28531753,4.93470009 4.28531753,5.7151949 C4.28531753,6.49568971 4.93378645,7.14415863 5.71428126,7.14415863 C6.49477607,7.14415863 7.14324499,6.49568971 7.14324499,5.7151949 C7.14324499,4.93470009 6.49477607,4.28623117 5.71428126,4.28623117 L5.71428126,4.28623117 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.3f113801b6b189300dede4c807b8108a.svg";
export { ForwardRef as ReactComponent };